module.exports = __webpack_public_path__ + "img/insurance-logo-16.423106ed.png";